import Api from './ApiService'

export default {
    get(keyword, pageNumber, sort) {
        return Api().get(`avaliacoes/adm?keyword=${keyword}&pageNumber=${pageNumber}&sort=${sort}`);
    },
    getOne(id) {
        return Api().get(`avaliacoes/${id}`);
    },
    create(data) {
        return Api().post(`avaliacoes`, data);
    },
    update(data) {
        return Api().put(`avaliacoes/${data.id}`, data);
    }
}